import { render } from "./GlossarySection.vue?vue&type=template&id=641478a0&scoped=true"
import script from "./GlossarySection.vue?vue&type=script&lang=js"
export * from "./GlossarySection.vue?vue&type=script&lang=js"

import "./GlossarySection.vue?vue&type=style&index=0&id=641478a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641478a0"]])

export default __exports__